import { render, staticRenderFns } from "./UploadInstructions.vue?vue&type=template&id=1d66916d&scoped=true&"
import script from "./UploadInstructions.vue?vue&type=script&lang=js&"
export * from "./UploadInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d66916d",
  null
  
)

export default component.exports